import React, { Component } from 'react'
import ReportGeneralTable from '../report/ReportGeneralTable'
import TyreStore from 'stores/TyreStore'
import TyreRetireDoc from './TyreRetireDoc'
import FontAwesome from 'react-fontawesome'
import { Popover, OverlayTrigger} from 'react-bootstrap'
import withSizes from 'react-sizes'

const cHeaderTitles = [
    {title:'วันที่',width:'100px'},
    {title:'หมายเลขใบยางหมดอายุ',width:'110px'},
    {title:'คำอธิบาย',width:'150px'},
    {title:'จำนวน',width:'100px'}
]
class ReportTyreRetirePage extends Component {
    constructor(props) {
      super(props)
      
      this.state = {
            showTable:true,
            showClose:false,
            loadClose:false
        }
    }

    loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback) {
        TyreStore.loadReportRetire(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
            callback(result)
        })
    }

    loadDataRange(start,end,searchBy,query,activePage,itemPerPage,callback){
        TyreStore.loadReportRetireRange(start,end,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
            callback(result)
        })
    }
  
    showTable(){
        this.setState({showTable:true,showClose:true,loadClose:true})
        if (this.props.onTableShow!==undefined){
          this.props.onTableShow()
        }
    }
    
    onRowSelect(item){
        this.setState({showTable:false,showClose:false,loadClose:false})
        this.refs.trDoc.loadData(item.tyre_retire_no)
        if (this.props.onDocShow!==undefined) {
            this.props.onDocShow(item.tyre_retire_no)
        }
    }
    
    onDocNew(){
        this.setState({showTable:false})
        this.refs.trDoc.loadNewDoc((item)=>{
            if (this.props.onDocShow!==undefined) {
                this.props.onDocShow(item.tyre_retire_no)
            }
        })
    }
    
    onDocClose(){
        this.showTable() 
    }

    onIconClick() {
        
    }
    
    onRenderColumn(data,col,row){ 
        if (col===1) {
            if (row.tyre_retire_no!=="") {
                let title = "ใบยางหมดอายุ "+row.tyre_retire_no
                let popoverHoverFocus = (
                    <Popover id="popover-trigger-hover-focus" title={title}>
                        <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
                    </Popover>
                )
    
                return(
                    <span>
                        {row.tyre_retire_no} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconClick.bind(this,row.tyre_retire_no)} className="text-blue" name='file-text-o'/></OverlayTrigger>
                    </span>
                )
            }
        } else {
            return (<span>{data}</span>)
        }
    }

    render() {
        let {showTable} = this.state

        const searchOptions = [
            {
              label: 'ใบยางหมดอายุ',
              value: 'tyre_retire_no'
            }
        ]
        return(
            <div>
                <div style={{display:showTable?'':'none'}}>
                    <ReportGeneralTable 
                        ref='trTable' 
                        title='ใบยางหมดอายุ' 
                        newTitle='เพิ่มรายการ'
                        show={this.state.showClose}
                        loadOnShow={this.state.loadClose}
                        showNewButton={true}
                        headerTitles={cHeaderTitles}
                        bodyColumn={['added_date','tyre_retire_no','description','amount']}                        
                        excludeClickColumn={[]}
                        searchOptions={searchOptions}          
                        searchBy={'tyre_retire_no'}
                        loadData={this.loadData.bind(this)}
                        loadDataRange={this.loadDataRange.bind(this)}
                        onRenderColumn={this.onRenderColumn.bind(this)}
                        onRowSelect={this.onRowSelect.bind(this)} 
                        onDocNew={this.onDocNew.bind(this)}
                        showPrintButton={false}
                        minWidth={'1280'}
                        isMobile={this.props.isMobile}
                        mobileFieldMap={{title:'request_by',amount:'amount',sub_title:'tyre_retire_no',date:'added_date',status:'',sub_status:''}}
                    />
                </div>
                <div style={{display:!showTable?'':'none'}}>
                    <TyreRetireDoc
                        ref='trDoc'
                        onShow={!showTable?true:false}
                        onCloseClick={this.onDocClose.bind(this)}
                    />
                </div>    
            </div>           
        )
    }
}

ReportTyreRetirePage.defaultProps = {
        
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 480,
  })
  
  export default ReportTyreRetirePage = withSizes(mapSizesToProps)(ReportTyreRetirePage);


// WEBPACK FOOTER //
// ./src/view/tyre/ReportTyreRetirePage.js